import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Search, Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { NAV } from "../data/content";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { MiniCart } from "./MiniCart";

export function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <nav
      data-testid="nav"
      className="sticky top-0 z-40 backdrop-blur-md bg-[#F4EDE2]/85 text-[#0C111C] border-b border-black/5"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="text-2xl md:text-[26px]"
          style={{ fontFamily: "Fraunces, serif" }}
        >
          YABA<span className="align-super text-xs">®</span>
        </Link>
        <div
          className="hidden md:flex items-center gap-8 text-sm"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          {NAV.map((n) => {
            const to =
              n === "Contact" ? "/contact" :
              n === "The Collection" ? "/collection" :
              n === "Shop" ? "/collection" :
              `/#${n.toLowerCase().replace(/\s/g, "-")}`;
            return (
              <Link
                key={n}
                to={to}
                data-testid={`nav-link-${n.toLowerCase().replace(/\s/g, "-")}`}
                className="hover:text-[#C8A96A] transition-colors"
              >
                {n}
              </Link>
            );
          })}
        </div>
        <div className="flex items-center gap-4 text-sm" style={{ fontFamily: "Inter, sans-serif" }}>
          <button
            data-testid="nav-search"
            aria-label="Search"
            className="hidden md:inline-flex hover:text-[#C8A96A]"
          >
            <Search size={18} />
          </button>
          <div className="hidden md:block">
            <LanguageSwitcher />
          </div>
          <MiniCart />
          <button
            data-testid="nav-menu"
            className="md:hidden"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden border-t border-white/10 bg-[#0C111C] text-[#F4EDE2]"
          >
            <div
              className="px-6 py-6 flex flex-col gap-4"
              style={{ fontFamily: "Inter, sans-serif" }}
            >
              {NAV.map((n) => {
                const to =
                  n === "Contact" ? "/contact" :
                  n === "The Collection" ? "/collection" :
                  n === "Shop" ? "/collection" :
                  `/#${n.toLowerCase().replace(/\s/g, "-")}`;
                return (
                  <Link
                    key={n}
                    to={to}
                    className="text-xl"
                    style={{ fontFamily: "Fraunces, serif" }}
                    onClick={() => setOpen(false)}
                  >
                    {n}
                  </Link>
                );
              })}
              <div className="mt-3 pt-4 border-t border-[#F4EDE2]/15">
                <LanguageSwitcher variant="mobile" />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
